import React from "react"

import { FEATURES_TYPE } from "@constants"
import NotFoundPage from "Pages/NotFound/Page"


export const NotFoundRoute = {
	id: FEATURES_TYPE.COMMON,
	path: "*",
	element: <NotFoundPage/>,
	noRender: true,
}